export enum SessionVisitStatus
{
    Open = 1,
    Close = 2
}